export default __webpack_public_path__ + "media/atlassian-ventures.49adb3fd64e2ab3d7370a36738f5218f.svg";